import type { CallToAction } from "@ebay/experience-types-ebay";
import type { AttrClass } from "marko/tags-html";
import { getPropsForClickTracking } from "../../utils/tracking";
export interface Input extends Marko.HTML.Div {
  type?: "icon-button" | "button";
  model: CallToAction;
  class?: AttrClass;
}

<if(input.model)>
  $ const {
    model,
    class: inputClass,
    type = "icon-button",
    ...htmlInput
  } = input;
  <div ...htmlInput class=[inputClass, "map-survey"] data-testid="map-survey">
    <!-- Need to use spread object due to eBay UI Core error, see https://github.com/eBay/ebayui-core/issues/2425 -->
    $ const linkProps = {
      href: model.action?.URL,
      target: "_blank",
      ...getPropsForClickTracking(model.action?.trackingList),
    };
    <if(type === "button")>
      <ebay-button class="feedback-button button" size="small" priority="tertiary" ...linkProps>
        ${model.text}
      </ebay-button>
    </if>
    <else>
      <ebay-icon-button class="icon-button" aria-label=model.accessibilityText title=model.accessibilityText ...linkProps>
        <ebay-feedback-16-icon/>
      </ebay-icon-button>
    </else>
  </div>
</if>
